import React from "react";
import { FormattedMessage } from "react-intl";

import { messages } from "./messages";
import { BackButton } from "components/BackButton";
import { IntroducingBrokerMembersTable } from "components/IntroducingBrokerMembersTable";

export const MembersPage: React.FC = () => {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="mb-2 flex flex-row items-center justify-between border-b border-[--milkylb-color-secondary-100]">
        <div className="mb-8 flex flex-col items-start justify-normal">
          <BackButton className="mb-4" />
          <h1 className="font-['Tomato_Grotesk'] text-4xl font-bold">
            <FormattedMessage {...messages.title} />
          </h1>
        </div>
      </div>
      <IntroducingBrokerMembersTable />
    </div>
  );
};
